/* eslint-disable react/prop-types */
import React from 'react';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useContext } from 'react';
import OnExitWhoCostForm from './OnExitWhoCostForm';
import StyledModal from '../molecules/StyledModal';
import image from '../../static/images/image-modal-how-cost.png';
import { NotificationModalContext } from '../../contexts/NotificationModalContext';

const useStyles = makeStyles({
  root: { backgroundColor: '#FFFFFF', overflow: 'hidden', borderRadius: '16px' },
  header: {
    backgroundColor: '#c3e7ff',
    display: 'flex',
    flexDirection: 'column',
    padding: '61px 36px 36px',
    borderRadius: '0 0 16px 16px',
    marginBottom: '10px',
    textAlign: 'center',
    '@media (max-width: 480px)': {
      padding: '15px 10px 10px',
      marginBottom: '5px',
    },

    '& h3': {
      color: '#046cb3',
      fontWeight: 600,
      fontSize: '14px',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontFamily: 'Nunito, sans-serif',
      lineHeight: '1.3',
      '@media (max-width: 480px)': {
        fontSize: '12px',
        marginBottom: '6px',
      },
      '@media (max-width: 360px)': {
        fontSize: '11px',
      },
    },

    '& p': {
      margin: '0 0 5px 0',
      fontSize: '15px',
      color: '#66647a',
      fontFamily: 'Nunito, sans-serif',
      lineHeight: '1.4',
      '@media (max-width: 480px)': {
        fontSize: '13px',
        marginBottom: '3px',
      },
      '@media (max-width: 360px)': {
        fontSize: '12px',
      },
    },
  },
  hero: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '15px',
    padding: '0 36px',
    marginTop: '-30px',
    flexShrink: 0,
    '@media (max-width: 480px)': {
      marginBottom: '10px',
      padding: '0 10px',
    },

    '& img': {
      maxWidth: '100%',
      height: 'auto',
      maxHeight: '212px',
      objectFit: 'contain',
      '@media (max-width: 480px)': {
        marginTop: '-20px',
        maxWidth: '70%',
        maxHeight: '120px',
      },
      '@media (max-width: 360px)': {
        maxHeight: '100px',
      },
    },
  },
  form: {
    padding: '0 36px 36px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 480px)': {
      padding: '0 15px 15px',
    },
    '@media (max-width: 360px)': {
      padding: '0 10px 10px',
    },
  },
});

export const ModalOnExitWhoCostModal = ({
  modalOpen, setModalOpen, tagWpp, tagPhone, tagWppId, tagPhoneId,
}) => {
  const classes = useStyles();
  const { setOpenModal: setOpenConfirmSubmitModal } = useContext(NotificationModalContext);

  return (
    <StyledModal open={modalOpen} setOpen={setModalOpen}>
      <div className={classes.root}>
        <div className={classes.header}>
          <h3>TEM ALGUMA DÚVIDA?</h3>
          <p>
            Vamos pensar numa solução personalizada para o seu negócio. Preencha seus dados que nosso time entrará em contato.
          </p>
        </div>

        <div className={classes.hero}>
          <img
            src={image}
            alt="Ilustração do modal"
          />
        </div>

        <Typography style={{
          padding: '0 36px 18px', fontWeight: 700, fontSize: '19px', lineHeight: 1.51,
        }}
        >
          Preencha as informações abaixo e fale com nosso time!
        </Typography>

        <div className={classes.form}>
          <OnExitWhoCostForm
            tagWpp={tagWpp}
            tagPhone={tagPhone}
            tagWppId={tagWppId}
            tagPhoneId={tagPhoneId}
            onSuccess={() => setOpenConfirmSubmitModal(true)}
            originModal={setModalOpen}
          />
        </div>
      </div>
    </StyledModal>
  );
};
